<script setup lang="ts">
  defineOptions({ name: 'CoursesAdminPreviewBanner' })

  import { computed } from 'vue'
  import { useRoute } from 'nuxt/app'

  import { createElementId } from '@common/core-layer/utils'

  import CPText from '@ui/components/CPText.vue'

  import { isCoursesAdminPreviewRoute } from '../utils/courses-admin-preview-url.utils'
  import { useCoursesAdminPreview } from '../composables/useCoursesAdminPreview'

  defineProps({
    message: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'sm',
    },
    weight: {
      type: String,
      default: 'medium',
    },
  })

  const route = useRoute()
  const { isActive, builderMode } = useCoursesAdminPreview()

  const coursesAdminPreviewBannerRootId = createElementId('courses', 'admin-preview', 'banner')

  // Path-gated too, so the banner doesn't linger a tick on non-courses routes after session clears.
  // Suppressed in builder mode since the HMI theme-builder iframe already frames this as an editor.
  const shouldShowBanner = computed(() => isActive.value && isCoursesAdminPreviewRoute(route.path) && !builderMode.value)
</script>

<template>
  <div
    v-if="shouldShowBanner"
    :id="coursesAdminPreviewBannerRootId"
    class="flex min-h-10 w-full shrink-0 items-center justify-center bg-primary px-4 py-2 shadow-sm"
    :class="classes || undefined"
    role="status"
    aria-live="polite"
  >
    <CPText :size="size" :weight="weight" class="text-on-primary">
      {{ message }}
    </CPText>
  </div>
</template>
